import { useState, useEffect, useRef } from 'react';
import { CreateRequest } from '../Enrichment/useRequestForUpdate';

// Total timeout set to 15 minutes
const TOTAL_TIMEOUT = 15 * 60 * 1000;
const POLLING_INTERVAL_IN_MS = 10000;
const PROGRESS_UPDATE_INTERVAL_IN_MS = 1000;

const createRequestViaSupportEmailRoute = '/api/jira/v1/sendRequestViaSupportEmail';

function useTenantDiscovery() {
  const [tenantDiscovery, setTenantDiscovery] = useState({
    fetching: false,
    error: false,
    success: false,
    data: false,
    expired: false,
    supportPending: false
  });
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const startTime = Date.now();

    const timer = setInterval(() => {
      const elapsedTime = Date.now() - startTime;
      const newProgress = (elapsedTime / TOTAL_TIMEOUT) * 100;
      if (newProgress >= 100) {
        setProgress(100);
        clearInterval(timer);
      } else {
        setProgress(newProgress);
      }
    }, PROGRESS_UPDATE_INTERVAL_IN_MS);
    return () => {
      clearInterval(timer);
    };
  }, []);
  const path = '/api/user/tenantDiscovery'
  const supportPendingPath = '/api/user/amsSupportPending';
  const timeoutRef = useRef(null);
  const pollingTimeoutRef = useRef(null);
  const mappingNotFoundError = "Mapping not found for the given identity provider and tenant identifier";
  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setTenantDiscovery(tenantDiscovery => ({
        ...tenantDiscovery, expired: true
      }));
      // clearing timeout
      clearTimeout(pollingTimeoutRef.current);
    }, TOTAL_TIMEOUT);
    return () => {
      clearTimeout(timeoutRef.current);
    }
  }, []);
  useEffect(() => {
    if (tenantDiscovery.expired && tenantDiscovery.data === false && tenantDiscovery.supportPending === true) {
      CreateRequest({
        summary: 'Quick enrollment unsupported AMS error',
        description: 'User was not able to start the tenant setup request due to unsupported AMS',
        category: process.env.REACT_APP_BASE_JIRA_TICKET_CATEGORY_ID,
      }, createRequestViaSupportEmailRoute, () => { });

    } else if (tenantDiscovery.expired && tenantDiscovery.data === false) {
      CreateRequest({
        summary: 'Quick enrollment tenant setup timeout',
        description: 'User was not able to start the tenant setup request in the given time frame',
        category: process.env.REACT_APP_BASE_JIRA_TICKET_CATEGORY_ID,
      }, createRequestViaSupportEmailRoute, () => { });
    }
  },
    [tenantDiscovery.data, tenantDiscovery.supportPending, tenantDiscovery.expired]);
  useEffect(() => {
    const getTenantDiscovery = async () => {
      setTenantDiscovery(tenantDiscovery => ({ ...tenantDiscovery, fetching: true, error: false, success: false, data: tenantDiscovery.data }));
      try {
        const response = await fetch(path + '?random=' + Math.random().toString(36).substring(2, 15));
        const responseObject = await response.json();
        // lastData.current = responseObject.data;
        if (responseObject.error === mappingNotFoundError) {
          const amsUnsupportedResponse = await fetch(supportPendingPath + '?random=' + Math.random().toString(36).substring(2, 15));
          const supportResponseObject = await amsUnsupportedResponse.json();
          if (!tenantDiscovery.expired && supportResponseObject.amsSupportPending === false) {
            pollingTimeoutRef.current = setTimeout(getTenantDiscovery, POLLING_INTERVAL_IN_MS);
          }
          setTenantDiscovery(tenantDiscovery => ({ ...tenantDiscovery, fetching: false, error: false, success: true, data: false, supportPending: supportResponseObject.amsSupportPending }));
        } else {
          setTenantDiscovery(tenantDiscovery => ({ ...tenantDiscovery, fetching: false, error: false, success: true, data: true }));
        }
      } catch (error) {
        setTenantDiscovery(tenantDiscovery => ({ ...tenantDiscovery, fetching: false, error: true, success: false, data: tenantDiscovery.data }));
      }
    }
    getTenantDiscovery();
    return () => {
      clearTimeout(pollingTimeoutRef.current);
    }
  }, []);
  return { tenantDiscovery, progress };
}

export { useTenantDiscovery };
